module.exports = __webpack_public_path__ + "img/4.41be3fb9.png";